/* nano Bewerten-Seite: progressives Formular, Upload-Vorschau, Absenden an n8n. */
(function () {
  'use strict';
  var root = document.querySelector('[data-section-type="nano-review-form"]');
  if (!root) return;
  var form = root.querySelector('[data-nrf-form]');
  var endpoint = root.dataset.nrfEndpoint;
  var maxFiles = parseInt(root.dataset.nrfMaxFiles || '3', 10);
  var params = new URLSearchParams(location.search);
  var token = params.get('t') || '';
  var productHandle = params.get('product') || '';
  var files = [];

  root.querySelector('[data-nrf-token]').value = token;
  root.querySelector('[data-nrf-product]').value = productHandle;
  if (!token) { form.hidden = true; root.querySelector('[data-nrf-noinvite]').hidden = false; return; }

  /* Kinderprodukt: Alters-Chips gegen Kind-Alter tauschen */
  function isKidsProduct(p) {
    var hay = [p.title || '', p.handle || '', productHandle].concat(p.tags || []).join(' ').toLowerCase();
    return hay.indexOf('kinder') !== -1;
  }
  function applyKidsMode() {
    var ageGroup = root.querySelector('[data-nrf-age-group]');
    var childGroup = root.querySelector('[data-nrf-child-group]');
    if (!ageGroup || !childGroup) return;
    ageGroup.hidden = true;
    root.querySelectorAll('input[name="age_group"]').forEach(function (i) { i.checked = false; i.disabled = true; });
    childGroup.hidden = false;
    root.querySelectorAll('input[name="child_age"]').forEach(function (i) { i.disabled = false; });
    var t = root.querySelector('[data-nrf-about-title]');
    if (t) t.textContent = 'Kurz zu euch';
  }

  /* Produktkarte aus dem Shop laden (kein API-Key nötig) */
  if (productHandle) {
    fetch('/products/' + encodeURIComponent(productHandle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var card = root.querySelector('[data-nrf-product-card]');
      card.querySelector('[data-nrf-product-name]').textContent = p.title;
      var img = card.querySelector('[data-nrf-product-img]');
      if (p.featured_image) { img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); } else { img.remove(); }
      card.hidden = false;
      var t = root.querySelector('[data-nrf-title]');
      if (t && /nano\?$/.test(t.textContent)) t.textContent = 'Wie gefällt dir ' + (p.title.replace(/\s*\|.*$/, '')) + '?';
      if (isKidsProduct(p)) applyKidsMode();
    }).catch(function () {});
  }

  /* Schritte nacheinander öffnen */
  var order = ['stars', 'attrs', 'text', 'about'];
  function reveal(step) {
    var idx = order.indexOf(step);
    order.slice(0, idx + 1).forEach(function (s) { root.querySelector('[data-nrf-step="' + s + '"]').hidden = false; });
  }

  /* Sterne */
  var hints = { 1: 'Das tut uns leid. Erzähl uns bitte, was schiefging.', 2: 'Danke für deine Ehrlichkeit.', 3: 'Okay, aber nicht überzeugt. Was fehlt?', 4: 'Fast perfekt. Was hat gefehlt?', 5: 'Das freut uns riesig!' };
  var starInputs = root.querySelectorAll('input[name="rating"]');
  function paintStars(v) {
    root.querySelectorAll('.nrf__star').forEach(function (l, i) { l.classList.toggle('is-on', i < v); });
    root.querySelector('[data-nrf-star-hint]').textContent = hints[v] || '';
    root.querySelector('[data-nrf-feedback]').hidden = !(v && v <= 3);
  }
  starInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { paintStars(parseInt(inp.value, 10)); reveal('about'); });
  });
  root.querySelectorAll('.nrf__star').forEach(function (l, i) {
    l.addEventListener('mouseenter', function () { root.querySelectorAll('.nrf__star').forEach(function (x, j) { x.classList.toggle('is-hover', j <= i); }); });
    l.addEventListener('mouseleave', function () { root.querySelectorAll('.nrf__star').forEach(function (x) { x.classList.remove('is-hover'); }); });
  });
  var pre = parseInt(params.get('stars') || '0', 10);
  if (pre >= 1 && pre <= 5) { starInputs[pre - 1].checked = true; paintStars(pre); reveal('about'); }

  /* Slider: 0 = keine Angabe */
  root.querySelectorAll('[data-nrf-range]').forEach(function (r) {
    var out = root.querySelector('[data-nrf-out="' + r.name + '"]');
    var labels = (r.dataset.labels || '|').split('|');
    function upd() { var v = parseInt(r.value, 10); out.textContent = v === 0 ? 'keine Angabe' : (v <= 2 ? labels[0] : v >= 4 ? labels[1] : 'mittel') + ' (' + v + '/5)'; }
    r.addEventListener('input', upd); upd();
  });

  /* Dateien */
  var fileInput = root.querySelector('[data-nrf-files]');
  var previews = root.querySelector('[data-nrf-previews]');
  function renderPreviews() {
    previews.innerHTML = '';
    files.forEach(function (f, i) {
      var li = document.createElement('li');
      var url = URL.createObjectURL(f);
      li.innerHTML = (f.type.indexOf('video') === 0 ? '<video src="' + url + '" muted></video>' : '<img src="' + url + '" alt="">') + '<button type="button" aria-label="Entfernen">×</button>';
      li.querySelector('button').addEventListener('click', function () { files.splice(i, 1); renderPreviews(); });
      previews.appendChild(li);
    });
  }
  if (fileInput) fileInput.addEventListener('change', function () {
    Array.prototype.forEach.call(fileInput.files, function (f) {
      if (files.length >= maxFiles) return;
      if (f.size > 25 * 1024 * 1024) { showError('„' + f.name + '“ ist größer als 25 MB.'); return; }
      files.push(f);
    });
    fileInput.value = ''; renderPreviews();
  });

  function showError(msg) { var e = root.querySelector('[data-nrf-error]'); e.textContent = msg; e.hidden = !msg; if (msg) e.scrollIntoView({ block: 'center', behavior: 'smooth' }); }

  /* Absenden */
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    showError('');
    var rating = form.querySelector('input[name="rating"]:checked');
    if (!rating) { showError('Bitte wähle zuerst deine Sterne.'); return; }
    if (!form.consent.checked) { showError('Bitte bestätige die Veröffentlichung.'); return; }
    if (!endpoint) { showError('Das Formular ist noch nicht verbunden. Bitte später erneut versuchen.'); return; }
    var fd = new FormData(form);
    fd.delete('media');
    files.forEach(function (f, i) { fd.append('media_' + i, f, f.name); });
    fd.append('media_count', String(files.length));
    fd.append('page_url', location.href);
    var btn = root.querySelector('[data-nrf-submit]');
    btn.disabled = true; btn.textContent = 'Wird gesendet …';
    fetch(endpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.ok === false) { throw new Error(res.j.message || 'Senden fehlgeschlagen. Bitte versuch es gleich noch einmal.'); }
        form.hidden = true;
        var done = root.querySelector('[data-nrf-done]'); done.hidden = false;
        if (res.j.next_product_handle) {
          var n = root.querySelector('[data-nrf-next-product]'); n.hidden = false;
          var a = root.querySelector('[data-nrf-next-link]');
          a.href = location.pathname + '?t=' + encodeURIComponent(res.j.next_token || token) + '&product=' + encodeURIComponent(res.j.next_product_handle);
          a.textContent = 'Auch „' + (res.j.next_product_title || 'das zweite Produkt') + '“ bewerten';
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (e) { showError(e.message); btn.disabled = false; btn.textContent = 'Bewertung absenden'; });
  });
})();
